import { MRT_ColumnDef } from 'mantine-react-table';
import { useMemo } from 'react';
import { InquiryLeadRow } from '../services/inquiryRows';
import { formatListDate, lastCommunicationColumn, nextTaskColumn } from './sharedColumns';

/**
 * Columns for the All inquiry queue.
 *
 * Every accessor tolerates a missing row — see the header of
 * `preConsultationColumns.tsx`: mantine-react-table calls `accessorFn` with
 * nothing on an empty table, and an accessor that assumes its row exists takes
 * the whole tab to the error boundary.
 */
export function useInquiryColumns(now: Date): MRT_ColumnDef<InquiryLeadRow>[] {
  return useMemo(
    () => [
      {
        id: 'firstName',
        header: 'First name',
        accessorFn: (row) => row?.patient?.name?.[0]?.given?.join(' ') ?? '',
      },
      {
        id: 'lastName',
        header: 'Last name',
        accessorFn: (row) => row?.patient?.name?.[0]?.family ?? '',
      },
      {
        id: 'location',
        header: 'Location',
        accessorFn: (row) => row?.location ?? '—',
      },
      {
        id: 'signupDate',
        header: 'Signup date',
        accessorFn: (row) => row?.signupAt ?? '',
        sortingFn: 'datetime',
        Cell: ({ row }) => formatListDate(row.original.signupAt) || '—',
      },
      {
        id: 'paymentMethod',
        header: 'Payment method',
        accessorFn: (row) => row?.paymentMethod ?? '—',
      },
      lastCommunicationColumn<InquiryLeadRow>(),
      nextTaskColumn<InquiryLeadRow>(now),
    ],
    [now]
  );
}
